import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Description } from "@material-ui/icons";

import CardTable from "components/CardTable/CardTable";
import { TableInputs } from "components/CardTable/TableInputs";
import { ModalV2 } from "components/Modal/ModalV2";
import { useSearch } from "hooks/useSearch";

import {
  getSpecialUnits,
  setSpecialUnitsFilters,
  deleteSpecialUnit,
} from "redux/actions/specialUnits/specialUnitsActions";
import { columns } from "./columns";
import { SPECIAL_UNITS_LABELS } from "./labels";
import SpecialUnitForm from "./SpecialUnitForm";

const { title, messages } = SPECIAL_UNITS_LABELS;

export default function SpecialUnitsView() {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { station, units, startDate, endDate } = useSelector((s) => s.specialUnits);
  const { isLoadingComp } = useSelector(({ search }) => search);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [formOpen, setFormOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const formRef = useRef(null);

  const loading = isLoadingComp?.loadingSpecialUnits;
  const deleting = isLoadingComp?.savingSpecialUnit;
  const saving = isLoadingComp?.savingSpecialUnit;

  const handleSubmit = (e) => {
    e?.preventDefault?.();
    if (!station?.id) return setSnackbar(messages.selectStation, "warning");
    if (!startDate || !endDate) return setSnackbar("Seleccione rango de fechas", "warning");
    dispatch(getSpecialUnits(station, startDate, endDate));
  };

  const handleEdit = (row) => {
    setEditData(row);
    setFormOpen(true);
  };

  const handleDelete = (row) => {
    setDeleteId(row.id);
    setConfirmOpen(true);
  };

  const confirmDelete = () => {
    dispatch(deleteSpecialUnit(deleteId, () => {
      setConfirmOpen(false);
    }));
  };

  const handleAdd = () => {
    setEditData(null);
    setFormOpen(true);
  };

  const handleCloseForm = () => {
    setFormOpen(false);
    setEditData(null);
  };

  return (
    <>
      <CardTable
        data={units}
        columns={columns(handleEdit, handleDelete)}
        hasHeader
        title={title}
        icon={<Description />}
        isLoading={loading}
        onChangePage={handleAdd}
        tableContent={
          <TableInputs
            stations
            dates
            reducer="specialUnits"
            dispatchAction={setSpecialUnitsFilters}
            submitAction={handleSubmit}
            loading={loading}
          />
        }
      />
      <ModalV2
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        justConfirm
        title="¿Eliminar esta unidad especial?"
        onSubmit={confirmDelete}
        confirmText="Eliminar"
        confirmColor="danger"
        loading={deleting}
      />
      <ModalV2
        open={formOpen}
        onClose={handleCloseForm}
        title={editData ? "Detalle Unidad Especial" : "Nueva Unidad Especial"}
        toRight
        onSubmit={editData ? null : () => formRef.current?.handleSave()}
        submitBtnText="Guardar"
        isLoading={saving}
      >
        {formOpen && (
          <SpecialUnitForm
            ref={formRef}
            editData={editData}
            station={station}
            onClose={handleCloseForm}
          />
        )}
      </ModalV2>
    </>
  );
}
